import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

import {RouterProvider} from "react-router-dom"
import {CartProvider} from "./providers/DashboardContext/index"
import {router} from "./routes/index"


const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)
root.render(
    <React.StrictMode>
        <CartProvider>
            <RouterProvider router={router}/>
            <App/>
        </CartProvider>
    </React.StrictMode>
)
// ReactDOM.render(
//   <React.StrictMode>
//     <RouterProvider router={router}/>
//     <CartProvider>
//         <App/>
//     </CartProvider>
//   </React.StrictMode>,
//   document.getElementById('root')
// );